type SkeletonProps = {
  /** Skeletons mimic the final layout, so the variant is the layout, not a size. */
  variant: 'rows' | 'ledger' | 'document';
  count?: number;
};

export function Skeleton({ variant, count = 5 }: SkeletonProps) {
  return (
    <div className={`skeleton skeleton--${variant}`} aria-busy="true" aria-live="polite">
      <span className="visually-hidden">Cargando…</span>
      {Array.from({ length: count }, (_, index) => (
        <span key={index} className="skeleton__block" />
      ))}
    </div>
  );
}
